import { module } from 'angular';
import { react2angular } from 'react2angular';

import { StatusGlyph } from './StatusGlyph';

export const STATUS_GLYPH_COMPONENT = 'spinnaker.core.task.statusGlyph.component';
module(STATUS_GLYPH_COMPONENT, [])
  .component('statusGlyph', react2angular(StatusGlyph, ['item']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/task/statusGlyph.component.ts